import { Outlet } from 'react-router';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { cn } from '@/lib/utils';
import { Menu, X } from 'lucide-react';
import { useSidebarDrawer } from '@/hooks/use-sidebar-drawer';

export function AppShell() {
  const { open: sidebarOpen, setOpen: setSidebarOpen, close } = useSidebarDrawer();

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          data-testid="sidebar-overlay"
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={close}
        />
      )}

      {/* Sidebar - hidden on mobile, shown on lg+ */}
      <div
        id="app-sidebar"
        className={cn(
          'fixed inset-y-0 left-0 z-50 w-64 transform transition-transform lg:relative lg:translate-x-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full',
        )}
      >
        <Sidebar onClose={close} />
      </div>

      <div className="flex flex-1 flex-col overflow-hidden">
        <Header
          leftAction={
            <button
              onClick={() => setSidebarOpen(true)}
              className="rounded-lg p-2 text-muted-foreground hover:bg-accent lg:hidden"
              aria-label={sidebarOpen ? 'Cerrar menú' : 'Abrir menú'}
              aria-expanded={sidebarOpen}
              aria-controls="app-sidebar"
            >
              {sidebarOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          }
        />
        <main className="flex-1 overflow-y-auto bg-background p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
